import { render, staticRenderFns } from "./UserMfa.vue?vue&type=template&id=ff14153c&scoped=true&"
import script from "./UserMfa.vue?vue&type=script&lang=js&"
export * from "./UserMfa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff14153c",
  null
  
)

export default component.exports